import script from "./NewOrder.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewOrder.vue?vue&type=script&setup=true&lang=ts"

import "./NewOrder.vue?vue&type=style&index=0&id=8cef3a96&scoped=true&lang=css"

import exportComponent from "/home/runner/work/binity-order/binity-order/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8cef3a96"]])

export default __exports__